import React, { useState } from "react";
import { InfoTip } from "@/components/InfoTip";
import { Coins, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const PRESETS = [20, 50, 100];

// Admin: offer prepaid credits (fixed, one-off cost) instead of a lifetime Pro pass.
export function AdminGrantCredits() {
  const [email, setEmail] = useState("");
  const [credits, setCredits] = useState(50);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/grant-credits", { email: email.trim(), credits: Number(credits) });
      toast.success(data.message);
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Échec de l'envoi des crédits.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="border border-[#002FA7] p-6 max-w-3xl mt-6" data-testid="admin-credits-form">
      <div className="sux-marker mb-2 flex items-center gap-2">
        <Coins className="w-3 h-3" /> Formateurs · ateliers
        <InfoTip testid="admin-grant-info" content={"Ajoute des crédits gratuits à un compte existant (formateur, testeur). Chaque crédit utilisé vous coûte un peu d'IA : offrez de petites quantités."} />
      </div>
      <h3 className="text-xl font-black tracking-tight mb-4" style={{ fontFamily: "Outfit" }}>
        Offrir des crédits
      </h3>
      <label htmlFor="credits-email" className="font-mono uppercase tracking-[0.2em] text-[10px] text-muted-foreground block mb-2">
        Email du bénéficiaire
      </label>
      <input
        id="credits-email"
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="formateur@reseau-canope.fr"
        className="w-full border border-border px-4 py-3 font-mono text-sm focus:outline-none focus:border-[#002FA7] bg-background mb-4"
        data-testid="admin-credits-email-input"
      />
      <div className="flex flex-wrap items-center gap-2">
        {PRESETS.map((n) => (
          <button
            key={n}
            type="button"
            onClick={() => setCredits(n)}
            data-testid={`admin-credits-preset-${n}`}
            className={`font-mono text-[12px] px-4 py-2 border transition-colors ${
              Number(credits) === n ? "bg-[#002FA7] text-white border-[#002FA7]" : "border-border hover:border-[#002FA7]"
            }`}
          >
            {n}
          </button>
        ))}
        <input
          type="number"
          min={1}
          max={1000}
          value={credits}
          onChange={(e) => setCredits(e.target.value)}
          className="w-24 border border-border px-3 py-2 font-mono text-sm bg-background"
          data-testid="admin-credits-amount-input"
          aria-label="Nombre de crédits"
        />
        <button
          type="submit"
          disabled={busy}
          data-testid="admin-credits-submit-btn"
          className="ml-auto font-mono uppercase tracking-[0.2em] text-[11px] bg-[#002FA7] text-white px-6 py-3 hover:bg-[#00227A] transition-colors disabled:opacity-50 flex items-center gap-2"
        >
          {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Coins className="w-3 h-3" />} Offrir {credits} crédits
        </button>
      </div>
      <p className="mt-3 text-xs text-muted-foreground font-mono">
        Coût fixe et limité (≈ 0,02 € par crédit utilisé). Les crédits s&apos;ajoutent au solde, sans expiration.
      </p>
    </form>
  );
}

export default AdminGrantCredits;
